import { z } from '../zod';

export const OrderBumpPageTypeValidationSchema = z.enum(['checkout', 'event']).meta({
  description:
    'The kind of page the order bump is on: `checkout` for a checkout page, `event` for an event (where order bumps are shown as add-ons).',
  example: 'checkout',
});

export const OrderBumpShowHideSubjectValidationSchema = z
  .enum(['price', 'ticket', 'order_bump'])
  .meta({
    description:
      'What the rule watches. `price`: the page product price the customer picked (checkout pages). `ticket`: the ticket types in the basket (events). `order_bump`: whether other order bumps on the page are ticked.',
    example: 'price',
  });

export const OrderBumpShowHideComparisonValidationSchema = z.enum(['is', 'is_not']).meta({
  description:
    '`is` shows the order bump while the watched selection matches; `is_not` shows it while it does not.',
  example: 'is',
});
